module.exports = __webpack_public_path__ + "components/MapControl/svg/Zamek.svg?50a4688d";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Zamek.svg
// module id = 2053
// module chunks = 0